import { AddressTab } from './AddressTab';
import { CoordinatesTab } from './CoordinatesTab';
import { MapTab } from './MapTab';

export const Tabs = {
  AddressTab,
  CoordinatesTab,
  MapTab,
};
